import type { App } from '@grafikr/components';

import intersectionLoader from 'utils/loaders/intersection';
import onEvent from 'utils/loaders/on-event';
import onElementInteraction from 'utils/loaders/on-element-interaction';
import hasUrlParam from 'utils/loaders/has-url-param';
import productForm from 'pages/product/form'
import hybridForm from 'pages/product/hybrid-form'

import header from 'layout/header';

export default (app: App) => {
  app.add({
    // Layout
    header,
    'search-modal': [
      onElementInteraction,
      () => import(/* webpackChunkName: "layout-search-modal" */ 'layout/search-modal'),
    ],

    // Components
    'cart-count': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-cart-count" */ 'components/cart-count'),
    ],
    'scroll-to-next': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-scroll-to-next" */ 'components/scroll-to-next'),
    ],
    gorgias: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-gorgias" */ 'components/gorgias'),
    ],
    'mobile-menu': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-mobile-menu" */ 'components/mobile-menu'),
    ],
    'klaviyo-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-klaviyo-form" */ 'components/klaviyo-form'),
    ],
    'filter-button': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-filter-button" */ 'components/filter-button'),
    ],
    'quick-buy': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-quick-buy" */ 'components/quick-buy'),
    ],
    'address-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-address-form" */ 'components/address-form'),
    ],
    'sticky-atc': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-sticky-atc" */ 'components/sticky-atc'),
    ],
    'add-to-cart-modal': [
      [onEvent, onElementInteraction],
      () =>
        import(
          /* webpackChunkName: "component-add-to-cart-modal" */ 'components/add-to-cart-modal'
        ),
    ],
    'cart-drawer': [
      [onEvent, onElementInteraction, hasUrlParam],
      () => import(/* webpackChunkName: "component-cart-drawer" */ 'components/cart-drawer'),
    ],
    copy: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-copy" */ 'components/copy'),
    ],
    audio: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-audio" */ 'components/audio'),
    ],
    slider: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-slider" */ 'components/slider'),
    ],
    newsletter: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-newsletter" */ 'components/newsletter'),
    ],
    'lazy-content': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-lazy-content" */ 'components/lazy-content'),
    ],
    pagination: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-pagination" */ 'components/pagination'),
    ],
    accordion: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-accordion" */ 'components/accordion'),
    ],
    'filter-accordion': [
      onElementInteraction,
      () =>
        import(/* webpackChunkName: "component-filter-accordion" */ 'components/filter-accordion'),
    ],
    video: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-video" */ 'components/video'),
    ],
    'video-modal': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-video-modal" */ 'components/video-modal'),
    ],
    explainer: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-explainer" */ 'components/explainer'),
    ],
    'algolia-carousel': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "component-algolia-carousel" */ 'components/algolia-carousel'),
    ],

    // Pages
    product: [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-main" */ 'pages/product/main'),
    ],
    'product-form': productForm,
    'hybrid-form': hybridForm,
    'product-gift-card': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-gift-card" */ 'pages/product/gift-card'),
    ],
    'product-recommendations': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "product-recommendations" */ 'pages/product/recommendations'),
    ],
    'collection-filter': [
      intersectionLoader,
      () => import(/* webpackChunkName: "collection-filter" */ 'pages/collection/filter'),
    ],
    'search-page': [
      intersectionLoader,
      () => import(/* webpackChunkName: "search-main" */ 'pages/search/main'),
    ],
    'auth-page': [
      intersectionLoader,
      () => import(/* webpackChunkName: "auth-main" */ 'pages/auth/main'),
    ],
  });
};
